import * as React from "react";
const alliances = [{
  id: 1,
  name: "Owens Corning",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660464/img/partner_logo_owens_corning.png"
}, {
  id: 3,
  name: "GAF Materials",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660464/img/partner_logo_gaf.png"
}, {
  id: 4,
  name: "CertainTeed",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660464/img/partner_logo_certainteed.png"
}, {
  id: 6,
  name: "Velux Skylights",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660464/img/partner_logo_velux.png"
}];
export default function StrategicAlliances() {
  return <section data-section-id="222631" id="trusted-partners" className="bg-background text-foreground py-16 md:py-24 border-y border-border/50">
      <div className="container mx-auto px-4 md:px-6">
        <div className="flex flex-col items-center justify-center space-y-10">
          <h2 className="font-default text-sm font-bold uppercase tracking-widest text-primary text-center">
            The Brands We Trust
          </h2>
          
          <div className="flex flex-wrap items-center justify-center gap-x-12 gap-y-10 md:gap-x-20 lg:gap-x-24">
            {alliances.map((alliance, i) => <div key={alliance.id} data-index={i} className="flex items-center justify-center">
                <img src={alliance.src} alt={`${alliance.name} logo`} className="h-8 md:h-10 w-auto object-contain grayscale opacity-60 transition-all duration-300 hover:grayscale-0 hover:opacity-100" loading="lazy" />
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}